import React from 'react';
import StatusTag from '../../hooks/StatusHook';

const ReconcileColums = ({ t }) => {
  const columnsPayment = [
    {
      title: t.id,
      dataIndex: 'reference_name',
    },
    {
      title: t.amount,
      dataIndex: 'amount',
    },
    // {
    //   title: t.costCenter,
    //   dataIndex: 'cost_center',
    // },
    {
      title: t.differenceAmount,
      dataIndex: 'difference_amount',
    },
    // {
    //   title: t.exchangeRate,
    //   dataIndex: 'exchange_rate',
    // },
    {
      title: t.postingDate,
      dataIndex: 'posting_date',
    },
    // {
    //   title: t.status,
    //   dataIndex: 'docstatus',
    //   render: (status) => <StatusTag status={status} />,
    // },
    // {
    //   title: t.action,
    //   dataIndex: 'docstatus',
    //   key: 'docstatus',
    //   render: (text, record) => {
    //     // console.log('record:', record);
    //     const enable_submit = record?.status === 'Draft' ? true : false;

    //     return (
    //       <Space>
    //         <Button
    //           size="small"
    //           type="primary"
    //           onClick={() => navigate(`/payment-entry/${record?.name}`)}
    //         >
    //           {text === 0 ? <MdModeEditOutline /> : <MdVisibility />}
    //         </Button>
    //         <Popconfirm
    //           title={t.Deletethepaymententry}
    //           description={t.areYouSure}
    //           onConfirm={() => handleRemove.mutate(record.name)}
    //           // onCancel={cancel}
    //           okText={t.yes}
    //           cancelText={t.no}
    //         >
    //           <Button size="small" type="primary" danger>
    //             <MdDelete />
    //           </Button>
    //         </Popconfirm>
    //         {enable_submit && (
    //           <Popconfirm
    //             title={t.SubmitthePaymentEntry}
    //             description={t.areYouSure}
    //             onConfirm={() => onSubmitSalesInvoice(record.name)}
    //             // onCancel={cancel}
    //             okText={t.yes}
    //             cancelText={t.no}
    //           >
    //             <Popover
    //               placement="top"
    //               title={t.submit}
    //               // onConfirm={() => onSubmitSalesInvoice(record.name)}
    //             >
    //               <Button
    //                 size="small"
    //                 type="primary"
    //                 style={{ backgroundColor: '#28a745', border: 0 }}
    //               >
    //                 <FaFileInvoiceDollar />
    //               </Button>
    //             </Popover>
    //           </Popconfirm>
    //         )}
    //       </Space>
    //     );
    //   },
    // },
  ];
  const columnsInvoice = [
    {
      title: t.id,
      dataIndex: 'invoice_number',
    },
    {
      title: t.amount,
      dataIndex: 'amount',
    },
    {
      title: t.outstandingAmount,
      dataIndex: 'outstanding_amount',
    },
    // {
    //   title: t.exchangeRate,
    //   dataIndex: 'exchange_rate',
    // },
    {
      title: t.invoiceDate,
      dataIndex: 'invoice_date',
    },
    // {
    //   title: t.status,
    //   dataIndex: 'docstatus',
    //   render: (status) => <StatusTag status={status} />,
    // },
  ];
  return {
    columnsPayment,
    columnsInvoice,
  };
};

export default ReconcileColums;
